export const groups = {
  notAssignedGroups:
    'No assigned groups — select one from the list to assign to an option',
  name: 'Name',
  code: 'Code',
  startAt: 'Start date',
  expiresAt: 'Expiration date',
  addingGroup: 'Adding a new group',
  addGroup: 'Add group',
  editGroup: 'Edit group',
  assignGroupToOption: 'Package/Group not assigned to options',
  deleteOptionTitle: 'Deleting option',
  deleteGroupTitle: 'Deleting group',
  deleteGroup: 'Delete group',
  deletedQuestion: 'Are you sure you want to delete the group "{groupName}"?',
  deleteOptionQuestion:
    'Are you sure you want to delete the option "{optionName}"?',
  options: 'Options',
  noOptions: 'No assigned options',
  linkGroup: 'Link group',
  unLinkGroup: 'Unlink group',
  unLinkOption: 'Unlink option',
  linkOption: 'Link option',
  selectOption: 'Select option...',
  noGroups: 'No groups have been created yet',
  linkedOption: 'Linked new option to group',
  unlinkedOption: 'Unlinked option from group',
  manageGroupsDescription:
    'Manage groups and their assignments to options. Groups allow for collective assignment of multiple options, making it easier to organize and manage offers.',
}
